export default "__VITE_ASSET__D$qsxQ3z__"